var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.link)?_c('a',{staticClass:"block button is-primary is-rounded",attrs:{"href":_vm.link,"target":this.block.target_blank ? '_blank' : '_self'}},[_vm._v(" "+_vm._s(this.block.button_label)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }